import { Box, Button, Grid } from "@mui/material";
import { StatisticsCard } from "./StatisticsCard";
import { useCallback, useEffect, useState } from "react";
import apiService from "../../../../../../service/Api";
import { showErrorToast } from "../../../../../../components/common/ShowToast";

interface StreamResult {
  approved_comments: number;
  total_comments: number;
  is_delivered: boolean;
  is_memory_book_available: boolean;
  assignees: { id: number }[];
}

interface Stats {
  total_memories: number;
  pending_review: number;
  approved: number;
  contacts_collected: number;
}

interface MemoryTableStatsProps {
  bookingId?: number;
  refresh?: number;
}

export const MemoryTableStats: React.FC<MemoryTableStatsProps> = ({ bookingId, refresh }) => {
  const [stats, setStats] = useState<Stats | null>(null);
  //const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchStats = useCallback(async () => {
    if (!bookingId) return;
    //setIsLoading(true);
    setError(false);
    try {
      const response = await apiService.get<{ count: number; results: StreamResult[] }>(
        `/api/streams/stream/memory-book/?booking=${bookingId}&page_size=100`
      );
      const results = response.data.results;
      setStats({
        total_memories: results.reduce((sum, r) => sum + r.total_comments, 0),
        pending_review: results.reduce((sum, r) => sum + (r.total_comments - r.approved_comments), 0),
        approved: results.reduce((sum, r) => sum + r.approved_comments, 0),
        contacts_collected: results.reduce((sum, r) => sum + r.assignees.length, 0),
      });
    } catch {
      showErrorToast("Failed to load statistics.");
      setError(true);
    } finally {
      //setIsLoading(false);
    }
  }, [bookingId]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats, refresh]);

  // if (isLoading) {
  //   return (
  //     <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", bgcolor: "#fff", width: "100%", height: 120, borderRadius: 2, mb: 3 }}>
  //       <CircularProgress size={25} />
  //     </Box>
  //   );
  // }

  if (error) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", bgcolor: "#fff", width: "100%", height: 120, borderRadius: 2, mb: 3 }}>
        <Button variant="contained" onClick={fetchStats}>Retry</Button>
      </Box>
    );
  }

  return (
    <Grid container spacing={1} mb={3}>
      <StatisticsCard  statisticFigure={stats?.total_memories ?? 0} statisticTitle="Total Memories" />
      <StatisticsCard  statisticFigure={stats?.pending_review ?? 0} statisticTitle="Pending Review" />
      <StatisticsCard statisticFigure={stats?.approved ?? 0} statisticTitle="Approved" />
      <StatisticsCard  statisticFigure={stats?.contacts_collected ?? 0} statisticTitle="Contacts collected" />
    </Grid>
  );
};